import React from "react";
import { Award, Heart, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheStaffyStandard() {
  const {
    ref: iconRef1,
    isVisible: isVisible1
  } = useRevealOnScroll();
  const {
    ref: iconRef2,
    isVisible: isVisible2
  } = useRevealOnScroll();
  const {
    ref: iconRef3,
    isVisible: isVisible3
  } = useRevealOnScroll();
  const standards = [{
    title: "Elite Pedigree",
    description: "Every Cavalier carries a legacy of excellence. We meticulously select for conformation and heritage to ensure the classic beauty of the breed shines through.",
    icon: Award,
    ref: iconRef1,
    isVisible: isVisible1
  }, {
    title: "Health & Vitality",
    description: "Our comprehensive health protocols and rigorous genetic testing guarantee that your new companion starts life with the strongest possible foundation.",
    icon: ShieldCheck,
    ref: iconRef2,
    isVisible: isVisible2
  }, {
    title: "Gentle Temperament",
    description: "Raised in the heart of our home, our puppies are socialized early to nurture the affectionate and loyal nature that Cavaliers are world-renowned for.",
    icon: Heart,
    ref: iconRef3,
    isVisible: isVisible3
  }];
  return <section data-section-id="11655" id="our-philosophy" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 text-center md:mb-24">
          <h2 className="font-sans text-3xl font-bold text-foreground md:text-4xl lg:text-5xl tracking-tight">
            Raised with Intention
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 bg-[var(--chart-2)] opacity-80"></div>
        </div>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8 lg:gap-12">
          {standards.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center">
              <div ref={item.ref} className={cn("mb-6 flex h-20 w-20 items-center justify-center rounded-none bg-white shadow-sm transition-all duration-1000 ease-out", item.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
                <item.icon className="h-10 w-10 text-[var(--chart-1)]" strokeWidth={1.2} />
              </div>
              <h3 className="mb-4 font-sans text-xl font-semibold text-foreground md:text-2xl">
                {item.title}
              </h3>
              <p className="max-w-xs font-sans text-muted-foreground leading-relaxed text-lg">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}